import { Group, Loader, Stack, Text, Tooltip } from "@mantine/core";

import { NarrativeCardActions } from "../NarrativeCardActions/NarrativeCardActions";
import styles from "./NarrativeEnrollWaiting.module.css";

export interface NarrativeEnrollWaitingProps {
    /** Return to the send-link form to send again (mirrors legacy "Re-send link"). */
    onResend?: () => void;
    /** Disable re-send once the smart-link attempt cap is hit. */
    resendDisabled?: boolean;
    /** Minutes until the sent link expires (copy only). */
    expiryMinutes?: number;
}

/**
 * The Enroll step's post-send state — shown after the enrollment link is sent, while we wait for the
 * customer to enroll (the narrative equivalent of the legacy `WaitForEnrollment` screen). Completion
 * arrives asynchronously as the usual enrollment-event, which flips the whole surface to the success
 * screen; until then this holds the step with a re-send affordance.
 */
export const NarrativeEnrollWaiting = ({
    onResend,
    resendDisabled,
    expiryMinutes = 120,
}: NarrativeEnrollWaitingProps) => (
    <div className={styles.card}>
        <Stack gap={12}>
            <Group gap={10} align="center" wrap="nowrap">
                <Loader size="sm" color="var(--mantine-color-primary-3)" />
                <Text className={styles.heading}>Waiting on them to enroll</Text>
            </Group>
            <Text className={styles.sub}>Heads up — this link expires in {expiryMinutes} minutes.</Text>
        </Stack>
        {/* Single action → bottom-left inline link (Ricardo 2026-08-27). */}
        <NarrativeCardActions>
            <Tooltip label="The link can only be sent 3 times" position="bottom" disabled={!resendDisabled}>
                <NarrativeCardActions.Link onClick={onResend} disabled={resendDisabled}>
                    Re-send link
                </NarrativeCardActions.Link>
            </Tooltip>
        </NarrativeCardActions>
    </div>
);
